// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3xJoF","header":"PatientQuestionnaire_header__2OzSJ","info":"PatientQuestionnaire_info__2UyDC"};